import React, { useEffect, useState } from 'react';
import { onErrorShowMessage } from '~src/errors';
import ProjectItem from '../ProjectItem/ProjectItem';
import { FIND_USER_RECENT_CANVASES } from '../../~graphql/queries/editorProjects';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { Spinner } from 'react-bootstrap';
import { router } from '~src/router';

const RecentProjects = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState([]);

  const fetchEditorProjects = async (forceFetch = false) => {
    const limit = 12;

    try {
      const graphQlClient = await getGraphQlClient();

      let where = {};

      where.status = {
        equalTo: 'active',
      };

      const response = await graphQlClient.query({
        fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
        variables: { limit, where },
        query: FIND_USER_RECENT_CANVASES,
      });

      return unmarshalGraphqlResponse(response.data, 'findEditorCanvas');
    } catch (error) {
      onErrorShowMessage();
      console.error(error);
    }
  };

  useEffect(() => {
    const forceFetch = reload.length > 0;
    fetchEditorProjects(forceFetch)
      .then((result) => {
        setItems(result.edges);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        onErrorShowMessage();
      });
  }, [reload]);

  const showProject = (project) => {
    return (
      <ProjectItem
        setReload={setReload}
        key={project.objectId}
        objectId={project.objectId}
        name={project.metadata.servizioName}
        metadata={project.metadata}
        pagesPreview={project.editor_canvas_pages.edges?.map(
          (page) => page.node.preview?.url
        )}
        gifPreviewId={project.editor_canvas_pages.edges[0]?.node.gifPreviewId}
      />
    );
  };

  const toProjectsButton = () => (
    <a
      id="editor-btn-loader-goto-projects"
      href={`${process.env.ROUTE_PROJECTS}`}
      className="g-btn g-btn-outline g-btn-primary g-btn-size-md"
      onClick={(event) => {
        event.preventDefault();
        router.navigate(`${process.env.ROUTE_PROJECTS}`);
      }}
      aria-label="Cerca"
    >
      {/* Inline SVG so it inherits button color via currentColor */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M15.2 16.34a7.5 7.5 0 1 1 1.38-1.45l4.2 4.2a1 1 0 1 1-1.42 1.41l-4.16-4.16zm-4.7.16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
        />
      </svg>
      Cerca
    </a>
  );

  return (
    <>
      {loading && (
        <Spinner
          className="my-4 mx-auto text-dark"
          animation="border"
          size="lg"
          variant="info"
        />
      )}
      {!loading && items.length == 0 && (
        <h5 className="my-5 mx-auto text-dark">Nessun progetto trovato</h5>
      )}
      {items.map(showProject)}
      {items.length > 0 && toProjectsButton()}
    </>
  );
};

export default RecentProjects;
